<template>
  <PButton
    :type
    :label
    :severity
    :disabled
    :loading
    :size
    :class="[labelSize, rootClass || 'w-full']"
    :icon="icon" iconPos="right"
    @click="$emit('click', $event)"
  >
    <template v-if="$slots.default" #default>
      <slot />
    </template>
  </PButton>
</template>

<script setup>
const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'button',
  },
  severity: {
    type: String,
    default: 'primary',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  labelSize: {
    type: String,
    default: 'text-xl',
  },
  rootClass: {
    type: String,
    default: '',
  },
  loading: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: 'normal',
  },
  icon: {
    type: String,
    default: '',
  }
})

defineEmits(['click'])

</script>
